export enum TrainingType {
  PerformanceCategories,
  Skills
}
